import { useReducer, useCallback } from "react"
import {
    INITIAL_STATE_MODAL_CETIP_ESIN,
    CONFIG_MODAL_CETIP_ESIN,
} from "../constants/full-list-cetip-isin.const"

const reducer = {
    SET_SELECT: (state, payload) => ({ ...state, selectCetipIsin: payload }),
    SET_LOADING: (state, payload) => ({
        ...state,
        isLoadingModalData: payload,
    }),
    SET_ROWS: (state, payload) => ({
        ...state,
        row: payload,
        lastFetched: Date.now(),
    }),
    TOGGLE_MODAL: (state) => ({
        ...state,
        listFullModalVisible: !state.listFullModalVisible,
    }),
}

function modalReducer(state, action) {
    const fn = reducer[action.type]
    return fn ? fn(state, action.payload) : state
}

export function useCetipModal(emissaoService) {
    const [state, dispatch] = useReducer(
        modalReducer,
        INITIAL_STATE_MODAL_CETIP_ESIN
    )

    const searchListCetip = useCallback(
        async (value = "") => {
            const res = await emissaoService.listCetipIsinEmissao(value)
            return res.body.data
        },
        [emissaoService]
    )

    const loadFullListCetipIsin = useCallback(async () => {
        dispatch({ type: "SET_LOADING", payload: true })
        const dataEmission = await searchListCetip("")
        const rows = dataEmission?.map((obj, i) => ({ ...obj, id: i }))
        dispatch({ type: "SET_ROWS", payload: rows })
        dispatch({ type: "SET_LOADING", payload: false })
    }, [searchListCetip])

    const handleOpenModal = useCallback(async () => {
        dispatch({ type: "TOGGLE_MODAL" })
        const expired =
            !state.lastFetched ||
            Date.now() - state.lastFetched > CONFIG_MODAL_CETIP_ESIN.cacheTime
        if (expired) {
            await loadFullListCetipIsin()
        }
    }, [state.lastFetched, loadFullListCetipIsin])

    const handleRowClick = (params) => {
        const selectedValue = params?.row?.CETIP ?? params?.row?.ISIN
        dispatch({ type: "SET_SELECT", payload: selectedValue })

        dispatch({ type: "TOGGLE_MODAL" })
    }

    return {
        state,
        dispatch,
        handleOpenModal,
        handleRowClick,
        callBackOnChangeInputHeader: (value) =>
            dispatch({ type: "SET_SELECT", payload: value }),
    }
}
